import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  max-height: 100%;

  overflow: auto;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  overflow: auto;
  padding: 0 ${({ theme }) => theme.spacing(6)}
    ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(6)};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;

  & > :last-child {
    width: auto !important;
    flex: 0 0 auto;
  }
`;

export const Label = styled.label<{ $disabled?: boolean; $alignTop?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  // min-width: 20rem;
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  flex: 1;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    flex-shrink: 0;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.45;
    `};

  ${({ $alignTop }) =>
    $alignTop &&
    css`
      align-self: flex-start;
    `};
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  min-height: 1px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.palette.grey[400]};
`;

export const LabelText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[700]};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(3)}`};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;

export const FormButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const DurationFields = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;
